import { getAbility } from "../../../reducers/sessionReducer";
import { store } from "../../../store";

const state = store.getState();

const assetClassificationTableColumns = [
  {
    name: "category",
    title: "Categoria",
    editable: false,
    width: 170,
  },
  {
    name: "className",
    title: "Classe",
    editable: false,
    width: 133,
  },
  {
    name: "subcategory",
    title: "Subclasse",
    editable: false,
  },
  {
    name: "toleranceRange",
    title: "Margem",
    editable: getAbility(state).can("update", "AssetClassification"),
    type: "number",
    width: 100,
    visible: getAbility(state).can("update", "AssetClassification"),
  },
  {
    name: "suggestedFund1Name",
    title: "1ª Sugestão de Fundo",
    width: 350,
  },
  {
    name: "suggestedFund2Name",
    title: "2ª Sugestão de Fundo",
    width: 350,
  },
  {
    name: "suggestedFund3Name",
    title: "3ª Sugestão de Fundo",
    width: 350,
  },
  {
    name: "minConsAllocation",
    title: "Conservador - Mínimo",
    type: "percentage",
    width: 230,
  },
  {
    name: "recConsAllocation",
    title: "Conservador - Recomendado",
    type: "percentage",
    editable: getAbility(state).can("update", "AssetClassification"),
    width: 230,
  },
  {
    name: "maxConsAllocation",
    title: "Conservador - Máximo",
    type: "percentage",
    width: 230,
  },
  {
    name: "minConsModAllocation",
    title: "Mod-Conservador - Mínimo",
    type: "percentage",
    width: 230,
  },
  {
    name: "recConsModAllocation",
    title: "Mod-Conservador - Recomendado",
    type: "percentage",
    editable: getAbility(state).can("update", "AssetClassification"),
    width: 230,
  },
  {
    name: "maxConsModAllocation",
    title: "Mod-Conservador - Máximo",
    type: "percentage",
    width: 230,
  },
  {
    name: "minModAllocation",
    title: "Moderado - Mínimo",
    type: "percentage",
    width: 230,
  },
  {
    name: "recModAllocation",
    title: "Moderado - Recomendado",
    type: "percentage",
    editable: getAbility(state).can("update", "AssetClassification"),
    width: 230,
  },
  {
    name: "maxModAllocation",
    title: "Moderado - Máximo",
    type: "percentage",
    width: 230,
  },
  {
    name: "minModAggrAllocation",
    title: "Mod-Arrojado - Mínimo",
    type: "percentage",
    width: 230,
  },
  {
    name: "recModAggrAllocation",
    title: "Mod-Arrojado - Recomendado",
    type: "percentage",
    width: 230,
    editable: getAbility(state).can("update", "AssetClassification"),
  },
  {
    name: "maxModAggrAllocation",
    title: "Mod-Arrojado - Máximo",
    type: "percentage",
    width: 230,
  },
  {
    name: "minAggrAllocation",
    title: "Arrojado - Mínimo",
    type: "percentage",
    width: 230,
  },
  {
    name: "recAggrAllocation",
    title: "Arrojado - Recomendado",
    type: "percentage",
    editable: getAbility(state).can("update", "AssetClassification"),
    width: 230,
  },
  {
    name: "maxAggrAllocation",
    title: "Arrojado - Máximo",
    type: "percentage",
    width: 230,
  },
];

const assetClassificationTableLeftFixedColumns = [
  "operations",
  "category",
  "className",
  "subcategory",
  "toleranceRange",
];

export { assetClassificationTableLeftFixedColumns };
export default assetClassificationTableColumns;
